import store from 'src/redux/store';

class MasterPermissions {
  constructor() {
    this.permissionFramework = [];
  }

  //FUTURE: Remove this method and it's usage as CheckPermission method takes care of fetching data from REDUX
  getPermissionFramework() {
    return this.permissionFramework;
  }

  //FUTURE: Remove this method and it's usage as CheckPermission method takes care of fetching data from REDUX
  setPermissionFramework(permissionFramework) {
    this.permissionFramework = permissionFramework;
  }

  CheckPermission = (featureName) => {
    let permissionFwkLen = 0;
    let bPermissionSet = false;

    const permissionsettings = store.getState().user.userRoleAndPermissions;
    this.permissionFramework = permissionsettings;

    permissionFwkLen = this.permissionFramework?.length || 0;

    for (let idx = 0; idx < permissionFwkLen; idx++) {
      if (
        this.permissionFramework[idx].level === 'level-0' &&
        this.permissionFramework[idx].GroupName === featureName &&
        this.permissionFramework[idx].GroupEnabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-1' &&
        this.permissionFramework[idx].PermissionLevel1 === featureName &&
        this.permissionFramework[idx].PermissionLevel1Enabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-2' &&
        this.permissionFramework[idx].PermissionLevel2 === featureName &&
        this.permissionFramework[idx].PermissionLevel2Enabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-3' &&
        this.permissionFramework[idx].PermissionLevel3 === featureName &&
        this.permissionFramework[idx].PermissionLevel3Enabled === true
      ) {
        bPermissionSet = true;
      }
      if (
        this.permissionFramework[idx].level === 'level-4' &&
        this.permissionFramework[idx].PermissionLevel4 === featureName &&
        this.permissionFramework[idx].PermissionLevel4Enabled === true
      ) {
        bPermissionSet = true;
      }
    }
    return bPermissionSet;
  };

  resetPermissionFramework() {
    this.permissionFramework = [];
  }
}

export default new MasterPermissions();
